import { Spin, Table, Input, Space, Tooltip } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { primiseTable } from "../../../actionsMethods/masterMethods";
import { serialNum, convertDate } from "../../../utils";
import "./style.scss";
import { useNavigate } from "react-router";
import eye_icon from "../../../assests/images/eyeIcon.svg";
import axios from "axios";
import { getToken } from "../../../utils/worker";

import search_icon from "../../../assests/images/search-icon.svg";

import React, { useEffect, useState } from "react";
import { APIs } from "../../../utils/worker";
import API from "../../../api";

function ViewAllCp({ key }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [totalMainPageSize, setTotalMainPageSize] = useState(0);
  const [searchLoad, setSearchLoad] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const { fetching: loading, result: result } = useSelector(
    (state) => state?.masterReducer?.premiseTableReducer,
    shallowEqual
  );

  useEffect(() => {
    setPageNum(0);
    // dispatch(primiseTable(userData?.emailId));
    getManifestList("?pageNum=0&pageSize=10");
  }, [key]);

  useEffect(() => {
    if (result) {
      let temp = [];
      for (let i = 0; i < result.length; i++) {
        console.log(result[i]?.premiseDto.createdDate);
        temp.push({
          createdDate: result[i]?.premiseDto.createdDate,
          premiseName: result[i]?.premiseDto.premiseName,
          pincode: result[i]?.premiseDto.pincode,
          city: result[i]?.premiseDto.city,
          state: result[i]?.premiseDto.state,
          zone: result[i]?.premiseDto.zone,
          id: result[i].premiseDto.premiseId,
        });
      }
      setData(temp);
      setTotalMainPageSize(result?.cpCount);
      setTotalPageSize(result?.cpCount);
    }
  }, [result]);

  const viewDetails = (record) => {
    navigate("/view-details", {
      state: { name: "view", id: record.id },
    });
    // navigate("/view-details", {record.premiseId);
  };

  const columns = [
    {
      title: "Sl No",
      dataIndex: "key",
      key: "key",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Created On",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (_, a) => convertDate(a?.createdDate),
    },
    {
      title: "CP Name",
      dataIndex: "premiseName",
      key: "premiseName",
      // render: (_, a) => a?.premiseDto?.premiseName,
    },
    {
      title: "PIN code",
      dataIndex: "pincode",
      key: "pincode",
      render: (_, a) => a?.premiseDto?.pincode || "NA",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (_, a) => a?.premiseDto?.city || "NA",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      // render: (_, a) => a?.premiseDto?.state,
    },
    {
      title: "Zone",
      dataIndex: "zone",
      key: "zone",
      // render: (_, a) => a?.premiseDto?.zone,
    },
    {
      title: "Actions",
      key: "action",
      fixed: "right",

      render: (record) => (
        <Space size="middle">
          <Tooltip title={"View"}>
            <img
              src={eye_icon}
              alt="edit"
              onClick={() => viewDetails(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const [lloading, setLoading] = useState(false);
  const [inputSearchValue, setInputSearchValue] = useState("");

  const getManifestList = async (page) => {
    setLoading(true);
    let response;

    response = await API.Api(
      `${APIs.baseURL}/cp-onboarding/v1/getAllCp${page}`
    ).getWithUserNPremiseHeader();
    const arr = response?.response?.data?.onboardCpDtos;
    let temp = [];
    for (let i = 0; i < arr?.length; i++) {
      temp.push({
        createdDate: arr[i]?.premiseDto.createdDate,
        premiseName: arr[i]?.premiseDto.premiseName,
        pincode: arr[i]?.premiseDto.pincode,
        city: arr[i]?.premiseDto.city,
        state: arr[i]?.premiseDto.state,
        zone: arr[i]?.premiseDto.zone,
        id: arr[i].premiseDto.premiseId,
      });
    }
    // let response = await API.Api(GET_MANIFEST_LIST).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      setData(temp);
      setTotalPageSize(response?.response?.data?.count);

      // setTableData(response?.response?.data?.data);
      // setTotalPage(response?.response?.data?.count);
    } else {
      message.error(response?.response?.data?.data?.message);
      setLoading(false);
    }
  };

  function handleChange(pagination) {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);

    // eslint-disable-next-line no-empty
    // if (inputSearch.length > 0) {
    // } else {
    //   dispatch(
    //     primiseTable(
    //       `?pageNo=${pagination.current - 1}&pageSize=${pagination.pageSize}`
    //     )
    //   );
    // }
    if (inputSearchValue == "") {
      getManifestList(
        `?pageNum=${pagination.current - 1}&pageSize=${pagination.pageSize}`
      );
    } else {
      onSearch(
        inputSearchValue,
        `?pageNum=${pagination.current - 1}&pageSize=${pagination.pageSize}`
      );
    }
  }
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const [dataSource, setDataSource] = useState(data);

  const filterArray = (dataSource, currValue) =>
    dataSource?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );

  // const onSearch = (e) => {
  //   const currValue = e.target.value;
  //   setInputSearchValue(currValue);
  //   const filteredData =
  //     inputSearchValue.length > 0 || inputSearchValue.length == 0
  //       ? filterArray(data, currValue)
  //       : filterArray(data, currValue);
  //   setDataSource(filteredData);
  // };

  const onSearch = async (e, page) => {
    // if (e.target.value.length < 3) {
    //   setPageSize(0);
    // }
    setLoading(true);
    setInputSearchValue(e);
    if (e.length >= 2) {
      let response = await API.Api(
        `${APIs.baseURL}/cp-onboarding/v1/${e + page}`
      ).getWithAllHeaders();
      console.log(response);
      if (response.status) {
        let arr = response?.response?.data?.onboardCpDtos;
        let temp = [];
        for (let i = 0; i < arr?.length; i++) {
          temp.push({
            createdDate: arr[i]?.premiseDto.createdDate,
            premiseName: arr[i]?.premiseDto.premiseName,
            pincode: arr[i]?.premiseDto.pincode,
            city: arr[i]?.premiseDto.city,
            state: arr[i]?.premiseDto.state,
            zone: arr[i]?.premiseDto.zone,
            id: arr[i].premiseDto.premiseId,
          });
        }
        // console.log(temp)
        setData(temp);
        setTotalPageSize(response?.response?.data?.count);

        // setFilteredData(resData);
        // setTotalPage(resData.length);
      } else {
        openMessage(response.response.data.message);
        setTableData([]);
        setFilteredData([]);
        // setTotalPage(tableData[0]?.count);
        setTotalPage(0);
        // message.error(response?.response?.data?.message);
      }
      setLoading(false);
    } else {
      setPageNum(0);
      setPageSize(10);
      getManifestList("?pageNum=0&pageSize=10");
    }
    // if (e.target.value.length < 1) {
    //   getManifestList("?pageNum=0&pageSize=10");
    //   setTotalPage(tableData[0]?.count);
    //   setCurrentPage(1);
    // }
  };

  return (
    <Spin spinning={loading || searchLoad || lloading}>
      <div>
        <div className="cp-template-container">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="cp-templet-heading"></div>
            <div className="text-right p-1">
              <Input
                placeholder="Search by CP name, Zone"
                bordered
                onChange={(e) =>
                  onSearch(e.target.value, "?pageNum=0&pageSize=10")
                }
                style={{ borderRadius: "5px", height: "40px", width: "400px" }}
                suffix={<img src={search_icon} />}
              />
            </div>
          </div>
          <Table
            dataSource={data}
            columns={columns}
            pagination={{
              pageSize: pageSize,
              total: totalPageSize,
              itemRender: itemRender,
              current: currentPage == 0 ? currentPage + 1 : currentPage,
            }}
            scroll={{
              x: 1500,
              y: 500,
            }}
            onChange={handleChange}
          />
        </div>
      </div>
    </Spin>
  );
}

export default ViewAllCp;
